/* All Reviews — infinite scroll.
 *
 * Every review Judge.me publishes to the theme is already in the DOM; this
 * reveals them a batch at a time as the visitor reaches the bottom, with the
 * button as the accessible fallback. Rendering server-side and revealing
 * client-side keeps the reviews in the HTML for search engines and for anyone
 * with JS off, who simply sees all of them at once.
 *
 * If `data-more-endpoint` is set, further pages are fetched from it once the
 * pre-rendered ones run out. It must return
 * { reviews: [ { html } | rendered card markup ], has_more: bool }.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.reviewsReady) return;
    root.dataset.reviewsReady = '1';

    var grid = root.querySelector('[data-reviews-grid]');
    var button = root.querySelector('[data-reviews-more]');
    var sentinel = root.querySelector('[data-reviews-sentinel]');
    var countEl = root.querySelector('[data-reviews-count]');
    if (!grid) return;

    var batch = parseInt(root.dataset.batch, 10) || 9;
    var endpoint = (root.dataset.moreEndpoint || '').trim();
    var page = 1;
    var exhausted = false;
    var busy = false;

    function hidden() {
      return grid.querySelectorAll('[data-review-hidden]');
    }

    function announce() {
      if (!countEl) return;
      var total = grid.children.length;
      var shown = total - hidden().length;
      countEl.textContent = shown >= total && !endpoint
        ? ''
        : 'Showing ' + shown + ' of ' + total + ' reviews';
    }

    function revealBatch() {
      var rest = hidden();
      var n = Math.min(batch, rest.length);
      for (var i = 0; i < n; i++) {
        rest[i].removeAttribute('hidden');
        rest[i].removeAttribute('data-review-hidden');
      }
      announce();
      return rest.length - n;
    }

    function fetchMore() {
      if (!endpoint || exhausted || busy) return;
      busy = true;
      if (button) button.setAttribute('aria-busy', 'true');
      page += 1;
      var sep = endpoint.indexOf('?') === -1 ? '?' : '&';
      fetch(endpoint + sep + 'page=' + page, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) {
          var items = (d && d.reviews) || [];
          if (!items.length) {
            exhausted = true;
          } else {
            var frag = document.createDocumentFragment();
            items.forEach(function (it) {
              var wrap = document.createElement('div');
              wrap.innerHTML = typeof it === 'string' ? it : (it.html || '');
              while (wrap.firstElementChild) frag.appendChild(wrap.firstElementChild);
            });
            grid.appendChild(frag);
            if (d.has_more === false) exhausted = true;
          }
          announce();
          if (button) button.hidden = exhausted;
        })
        .catch(function (err) {
          exhausted = true;
          if (button) button.hidden = true;
          if (window.console) console.warn('[all-reviews]', err);
        })
        .then(function () {
          busy = false;
          if (button) button.setAttribute('aria-busy', 'false');
        });
    }

    function advance() {
      if (hidden().length) {
        var left = revealBatch();
        if (button) button.hidden = left === 0 && !endpoint;
        return;
      }
      if (endpoint && !exhausted) {
        fetchMore();
      } else if (button) {
        button.hidden = true;
      }
    }

    if (button) button.addEventListener('click', advance);

    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && button && !button.hidden && !busy) advance();
      }, { rootMargin: '300px 0px' }).observe(sentinel);
    }

    announce();
  }

  function boot() {
    document.querySelectorAll('.all-reviews[data-batch]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
